module.exports = __webpack_public_path__ + "img/chevron-left.86bc926b.svg";